import './style';
import App from './Components/app';

export default App;
